import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2289f20c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "plugin-item-icon"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "plugin-item-content"
};
const _hoisted_4 = {
  class: "plugin-item_name"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  key: 0,
  class: "switch-on"
};
const _hoisted_7 = {
  class: "plugin-item_txt"
};
const _hoisted_8 = {
  class: "plugin-item-action"
};
const _hoisted_9 = {
  class: "plugin-item_btn"
};
const _hoisted_10 = {
  key: 0,
  class: "plugin"
};
const _hoisted_11 = {
  class: "plugin__body"
};
const _hoisted_12 = {
  class: "plugin__body-title"
};
const _hoisted_13 = {
  class: "plugin-item-icon"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "plugin-item-title"
};
const _hoisted_16 = {
  key: 0,
  class: "switch-on"
};
const _hoisted_17 = {
  key: 1,
  class: "switch-off"
};
const _hoisted_18 = {
  class: "plugin__body-sub"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "hr-solid"
}, null, -1));
const _hoisted_20 = {
  key: 0,
  class: "plugin__body-content"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more-action"
}, " 更多操作 ", -1));
const _hoisted_22 = {
  class: "user-select"
};
const _hoisted_23 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "plugin-item",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.handelShowAction(_ctx.plugin))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: _ctx.plugin.iconLink,
    class: "plugin-item_img",
    alt: "plugin",
    draggable: "false"
  }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.plugin.name), 1), _ctx.plugin.statusPhaseDesc === '打开' ? (_openBlock(), _createElementBlock("span", _hoisted_6, "已启动")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.plugin.description) + "；由" + _toDisplayString(_ctx.plugin.author) + "提供 ", 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "action",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.handleClick(_ctx.plugin.statusPhaseDesc), ["stop"]))
  }, _toDisplayString(_ctx.plugin.inProgress === 'in-percent' ? `${_ctx.plugin.progress}%` : _ctx.plugin.statusPhaseDesc), 1)])])]), (_openBlock(), _createBlock(_Teleport, {
    to: "#app"
  }, [_createVNode(_Transition, {
    name: "mask"
  }, {
    default: _withCtx(() => [_ctx.plugin.showAction ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "cover",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.handelShowAction(_ctx.plugin))
    })) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_Transition, {
    name: "pop"
  }, {
    default: _withCtx(() => [_ctx.plugin.showAction ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
      src: _ctx.plugin.iconLink,
      class: "plugin-item_img",
      alt: "plugin",
      draggable: "false"
    }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("h2", null, _toDisplayString(_ctx.plugin.name), 1), _ctx.plugin.statusPhaseDesc === '打开' ? (_openBlock(), _createElementBlock("span", _hoisted_16, "已启动")) : _createCommentVNode("", true), _ctx.plugin.statusPhaseDesc !== '打开' ? (_openBlock(), _createElementBlock("span", _hoisted_17, "未启动")) : _createCommentVNode("", true)]), _createElementVNode("a", {
      href: "javascript:;",
      class: "qh-icon-close",
      title: "关闭",
      onClick: _cache[3] || (_cache[3] = $event => _ctx.handelShowAction(_ctx.plugin))
    })]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.plugin.description) + "；由" + _toDisplayString(_ctx.plugin.author) + "提供 ", 1), _hoisted_19, _ctx.plugin.moreAction.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_hoisted_21, _createElementVNode("ul", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plugin.moreAction, (action, i) => {
      return _openBlock(), _createElementBlock("li", {
        key: i,
        class: "user-select-item",
        onClick: $event => _ctx.handleClick(action)
      }, _toDisplayString(action), 9, _hoisted_23);
    }), 128))])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
    _: 1
  })]))], 64);
}